/** Layouts */
import BaseLayout from '@/views/rh/formation_session/layouts/BaseLayout';
import EditLayout from '@/views/rh/formation_session/layouts/EditLayout';
import ShowLayout from '@/views/rh/formation_session/layouts/ShowLayout';

/** Components */
import Create from '@/views/rh/formation_session/components/Create';
import Edit from '@/views/rh/formation_session/components/Edit';
import Show from '@/views/rh/formation_session/components/Show';

import Document from '@/views/fichier/pages/Fichier';

/* Participation */
import ParticipationList from '@/views/rh/formation_session/components/participation/List';
import ParticipationAdd from '@/views/rh/formation_session/components/participation/Add';

/* Contrôle de présence */
import PresenceList from '@/views/rh/formation_session/components/presence/List';
import PresenceAdd from '@/views/rh/formation_session/components/presence/Add';

/* Agenda */
import Agenda from '@/views/rh/formation_session/components/agenda/Add';

export default [
  {
    path: '/rh/formation/session/:sprov',
    component: BaseLayout,
    children: [
      {
        path: 'create/:formationId',
        component: Create,
        name: 'rh_formation_session-create',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'edit/:sessionId',
        component: EditLayout,
        children: [
          {
            path: '',
            component: Edit,
            name: 'rh_formation_session-edit',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },

          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'rh_formation_session_edit-document',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'participation',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ParticipationList,
                name: 'rh_formation_session_edit_participation',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'add',
                component: ParticipationAdd,
                name: 'rh_formation_session_edit_participation-add',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'presence',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: PresenceList,
                name: 'rh_formation_session_edit_presence',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'add',
                component: PresenceAdd,
                name: 'rh_formation_session_edit_presence-add',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'agenda',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: Agenda,
                name: 'rh_formation_session_edit_agenda',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'show/:sessionId',
        component: ShowLayout,
        children: [
          {
            path: '',
            component: Show,
            name: 'rh_formation_session-show',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'rh_formation_session_show-document',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'participation',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ParticipationList,
                name: 'rh_formation_session_show_participation',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'add',
                component: ParticipationAdd,
                name: 'rh_formation_session_show_participation-add',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'presence',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: PresenceList,
                name: 'rh_formation_session_show_presence',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'add',
                component: PresenceAdd,
                name: 'rh_formation_session_show_presence-add',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'agenda',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: Agenda,
                name: 'rh_formation_session_show_agenda',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
